// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_WorkerShift = require("./CommonTypes_WorkerShift.bs.js");
var CommonTypes_Invoice_Flag = require("./CommonTypes_Invoice_Flag.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.flag;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$1) {
      case "ESTIMATED_SHIFT_PAY_MINIMUM" :
          tmp$1 = "ESTIMATED_SHIFT_PAY_MINIMUM";
          break;
      case "_24_HOUR_BUSINESS_CANCELLATION" :
          tmp$1 = "_24_HOUR_BUSINESS_CANCELLATION";
          break;
      case "_4_HOUR_MIN" :
          tmp$1 = "_4_HOUR_MIN";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$1
        };
    }
    tmp = tmp$1;
  }
  var value$2 = value.flagPayForBusiness;
  var value$3 = value.shiftsWorkerShiftsAccumulatorByWorkerShiftId;
  var value$4 = value.shiftPayForBusiness;
  return {
          flag: tmp,
          flagPayForBusiness: !(value$2 == null) ? value$2 : undefined,
          id: Curry._1(CommonTypes_WorkerShift.Id.GraphQL_API.parse, value.id),
          shiftsWorkerShiftsAccumulatorByWorkerShiftId: !(value$3 == null) ? ({
                id: value$3.id,
                isOverfill: value$3.isOverfill
              }) : undefined,
          shiftPayForBusiness: !(value$4 == null) ? value$4 : undefined
        };
}

function serialize(value) {
  var value$1 = value.shiftPayForBusiness;
  var shiftPayForBusiness = value$1 !== undefined ? value$1 : null;
  var value$2 = value.shiftsWorkerShiftsAccumulatorByWorkerShiftId;
  var shiftsWorkerShiftsAccumulatorByWorkerShiftId;
  if (value$2 !== undefined) {
    var value$3 = value$2.isOverfill;
    var value$4 = value$2.id;
    shiftsWorkerShiftsAccumulatorByWorkerShiftId = {
      id: value$4,
      isOverfill: value$3
    };
  } else {
    shiftsWorkerShiftsAccumulatorByWorkerShiftId = null;
  }
  var value$5 = value.id;
  var value$6 = Curry._1(CommonTypes_WorkerShift.Id.GraphQL_API.serialize, value$5);
  var value$7 = value.flagPayForBusiness;
  var flagPayForBusiness = value$7 !== undefined ? value$7 : null;
  var value$8 = value.flag;
  var flag = value$8 !== undefined ? (
      typeof value$8 === "string" ? (
          value$8 === "_4_HOUR_MIN" ? "_4_HOUR_MIN" : (
              value$8 === "_24_HOUR_BUSINESS_CANCELLATION" ? "_24_HOUR_BUSINESS_CANCELLATION" : "ESTIMATED_SHIFT_PAY_MINIMUM"
            )
        ) : value$8.VAL
    ) : null;
  return {
          flag: flag,
          flagPayForBusiness: flagPayForBusiness,
          id: value$6,
          shiftsWorkerShiftsAccumulatorByWorkerShiftId: shiftsWorkerShiftsAccumulatorByWorkerShiftId,
          shiftPayForBusiness: shiftPayForBusiness
        };
}

function verifyArgsAndParse(_CommonTypes_Invoice_WorkerShift, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function getIsOverfill(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Option.map((function (param) {
                              return param.isOverfill;
                            }), param);
              }), (function (param) {
                return Relude_Option.getOrElse(false, param);
              }), param);
}

function tToR(param) {
  var flagPayForBusiness = param.flagPayForBusiness;
  if (flagPayForBusiness === undefined) {
    return ;
  }
  var shiftPayForBusiness = param.shiftPayForBusiness;
  if (shiftPayForBusiness !== undefined) {
    return Relude_Option.pure({
                flag: CommonTypes_Invoice_Flag.make(Curry._2(Relude_Option.flatMap, CommonTypes_Invoice_Flag.FlagType.parseApiResponse, param.flag), getIsOverfill(param.shiftsWorkerShiftsAccumulatorByWorkerShiftId)),
                flagPayForBusiness: flagPayForBusiness,
                id: param.id,
                shiftPayForBusiness: shiftPayForBusiness
              });
  }
  
}

var query = "fragment CommonTypes_Invoice_WorkerShift on WorkerShift   {\nflag: unignoredFlag  \nflagPayForBusiness  \nid  \nshiftsWorkerShiftsAccumulatorByWorkerShiftId  {\nid  \nisOverfill  \n}\n\nshiftPayForBusiness  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.getIsOverfill = getIsOverfill;
exports.tToR = tToR;
/* Relude_Option Not a pure module */
